import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <>
      <div
        className={`fixed top-0 left-0 right-0 z-50 bg-orange-500 text-white text-center py-2 md:py-3 px-4 transition-all duration-300 ${
          isScrolled ? 'opacity-0 -translate-y-full pointer-events-none' : 'opacity-100 translate-y-0'
        }`}
      >
        <p className="text-xs md:text-sm font-bold tracking-wide flex items-center justify-center gap-2">
          <i className="ri-award-fill w-4 h-4 md:w-5 md:h-5 flex items-center justify-center text-yellow-300"></i>
          <span className="hidden sm:inline">미국 창의력 권위자 김경희 교수와 함께 연구하는 센터</span>
          <span className="sm:hidden">김경희 교수 연구 센터</span>
        </p>
      </div>
      <nav
        className={`fixed left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'top-0 bg-white shadow-md' : 'top-[32px] md:top-[40px] bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-3 md:py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-2 md:gap-3 cursor-pointer" onClick={() => scrollToSection('hero')}>
              <span className={`text-base md:text-xl font-bold transition-colors ${isScrolled ? 'text-gray-900' : 'text-white'}`}>
                씽크짐 창의융합놀이센터
              </span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-6 xl:gap-8">
              <button
                onClick={() => scrollToSection('hero')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
                }`}
              >
                홈
              </button>
              <button
                onClick={() => scrollToSection('brand')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
                }`}
              >
                브랜드 소개
              </button>
              <button
                onClick={() => scrollToSection('categories')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
                }`}
              >
                주요 카테고리
              </button>
              <button
                onClick={() => scrollToSection('programs')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
                }`}
              >
                교육 프로그램
              </button>
              <button
                onClick={() => scrollToSection('facilities')}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  isScrolled ? 'text-gray-700 hover:text-orange-500' : 'text-white hover:text-orange-300'
                }`}
              >
                시설 안내
              </button>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className={`lg:hidden w-10 h-10 flex items-center justify-center ${
                isScrolled ? 'text-gray-900' : 'text-white'
              }`}
            >
              <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 space-y-2">
              <button
                onClick={() => scrollToSection('hero')}
                className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isScrolled ? 'text-gray-700 hover:bg-orange-50 hover:text-orange-500' : 'text-white hover:bg-white/10'
                }`}
              >
                홈
              </button>
              <button
                onClick={() => scrollToSection('brand')}
                className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isScrolled ? 'text-gray-700 hover:bg-orange-50 hover:text-orange-500' : 'text-white hover:bg-white/10'
                }`}
              >
                브랜드 소개
              </button>
              <button
                onClick={() => scrollToSection('categories')}
                className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isScrolled ? 'text-gray-700 hover:bg-orange-50 hover:text-orange-500' : 'text-white hover:bg-white/10'
                }`}
              >
                주요 카테고리
              </button>
              <button
                onClick={() => scrollToSection('programs')}
                className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isScrolled ? 'text-gray-700 hover:bg-orange-50 hover:text-orange-500' : 'text-white hover:bg-white/10'
                }`}
              >
                교육 프로그램
              </button>
              <button
                onClick={() => scrollToSection('facilities')}
                className={`block w-full text-left px-4 py-3 rounded-lg text-sm font-medium transition-colors ${
                  isScrolled ? 'text-gray-700 hover:bg-orange-50 hover:text-orange-500' : 'text-white hover:bg-white/10'
                }`}
              >
                시설 안내
              </button>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
